// ===== Packages =====

import {
    collection,
    getFirestore,
    onSnapshot,
    orderBy,
    query,
    Unsubscribe,
}                                   from 'firebase/firestore';

// ===== Interfaces =====

import {
    IPostCollabDocCheckpointItem,
    ISubscribeToPostCollabDocCheckpointsParams,
}                                   from '../interfaces';

// ===== Enums =====

import {
    FIRESTORE_COLLECTION,
}                                   from '../enums';

const subscribeToPostCollabDocCheckpoints = ({
    test,
    docId,
    onNext,
    onError,
}: ISubscribeToPostCollabDocCheckpointsParams): Unsubscribe => {
    const firestore = getFirestore();
    const collabCollection = test
        ? FIRESTORE_COLLECTION.stagingPostCollabDocs
        : FIRESTORE_COLLECTION.postCollabDocs;

    return onSnapshot(
        query(
            collection(firestore, `${collabCollection}/${docId}/checkpoints`),
            orderBy('createdAt', 'desc'),
        ),
        (snapshot) => {
            onNext(snapshot.docs.map((docSnapshot) => (
                docSnapshot.data() as IPostCollabDocCheckpointItem
            )));
        },
        (error) => {
            if (onError) {
                onError(error);
                return;
            }

            onNext([]);
        },
    );
};

export default subscribeToPostCollabDocCheckpoints;
